/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { pressed: true },
      tokens: { paddingBottom: 0, paddingTop: 0 }
    }
  ],
  tokens: {
    backgroundColor: '#fafafa',
    borderTopColor: '#e3e6e8',
    borderTopWidth: 1,
    gap: 8,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4
  }
}
export default theme
